<div class="tm-cnt-ext">
    <div class="tm-cnt" [ngClass]="{'tm-cnt-mobile' : isMobile}">
        <div class="tm-cnt-title">
            <div class="tm-ico-cnt">
                <i *ngIf="isCreate" class="fal fa-plus tm-icon"></i>
                <i *ngIf="!isCreate" class="fal fa-pen tm-icon"></i>
            </div>
            <span class="te-title">{{modalTitle}}</span>
        </div>
        <div class="tm-cnt-body">
            <!-- <div class="tgs-col"> -->
                <teiasoft-input [type]="'text'" [isRequired]="true"
                    [isMobile]="isMobile" [isValid]="nameisValid" [labelText]="'enquiryBook.name'| translate" [noMargin]="true"
                    (onInput)="onInput($event, 'customerName')" [value]="dummyCustomer.customerName!"
                    style="width:100%" [tabIndex]="0"></teiasoft-input>
<!--                 <teiasoft-input [type]="'text'" [placeHolder]="'enquiryBook.country'| translate" [isRequired]="true"
                    [isMobile]="isMobile" [isValid]="countryisValid" [labelText]="'enquiryBook.country'| translate"
                    (onInput)="onInput($event, 'customerCountry')" [value]="(isCreate == false ? 'dummyCustomer.countryName'! : '')"></teiasoft-input> -->
                <teiasoft-select [labelText]="'enquiryBook.country'| translate" [isMobile]="isMobile"
                    [isRequired]="true" [optionsList]="customerCountries"
                    [isValid]="countryisValid"
                    (onSelected)="onSelected($event, 'CountryName')"
                    [defaultValue]="dummyCustomer.customerCountryId"
                    [noMinWidth]="true"
                    [autoComplete]="false"
                    [clearValue]="clearValueCountry"
                    style="width:100%"></teiasoft-select>


                <teiasoft-select [labelText]="'enquiryBook.UnitSystem'| translate" 
                    [isRequired]="true" [optionsList]="listOfOptions" [isMobile]="isMobile"
                    [isValid]="unitSystemIsValid"
                    (onSelected)="onSelected($event, 'UnitSystem')" 
                    [defaultValue]="dummyCustomer.unitSystem!"
                    [noMinWidth]="true"
                    [clearValue]="clearValueUnitSystem"
                    style="width:100%"></teiasoft-select>

            <!-- </div> -->
        </div>
        <div class="tm-cnt-btn" [ngClass]="{'tm-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onConfirmModalClick()" class="mr-5" [text]="'commons.save' | translate"
                [type]="'tb-secondary'" [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>